import React from 'react';
import { useDocumentTitle } from "../hooks/setDocumentTitle"
import { useEffect } from 'react';
function CrochetAlong() {

    useDocumentTitle("Crochet Along | Witty Crafts Design");
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        const href = window.location.href.substring(
            window.location.href.lastIndexOf('#') + 1,
        );
        if (window.location.href.lastIndexOf('#') > 0) {
            document.getElementById(href)?.scrollIntoView();
        }
    });

    return (
        <>
            <h1 className="fw-bold">Cuddle Up Blanket Crochet Along</h1>
            <div className="row text-center">
                <div className="card col-sm-12 col-md-4">
                    <img src="/media/cuddle-up-blanket-cal-1.jpg" alt="Cuddle Up Blanket CAL" className="img-fluid rounded shadow mb-3" />
                </div>
                <div className="card col-sm-12 col-md-4">
                    <img src="/media/cuddle-up-blanket-cal-2.jpg" alt="Cuddle Up Blanket CAL" className="img-fluid rounded shadow mb-3" />
                </div>
                <div className="card col-sm-12 col-md-4">
                    <img src="/media/cuddle-up-blanket-cal-3.jpg" alt="Cuddle Up Blanket CAL" className="img-fluid rounded shadow mb-3" />
                </div>
            </div>
            <p>Welcome to the Cuddle Up Blanket crochet along! This is my very first crochet along, and hopefully the first of many.</p>
            <p>I am absolutely delighted that so many of you are joining this crochet along. I know that many of you will be following the original colour scheme and have purchased the <a href="https://www.woolwarehouse.co.uk/packs/sylwia-witty-witty-crafts-design-cuddle-up-blanket-yarnsmiths-yarn-pack" target="_blank" rel="noreferrer">yarn pack</a>. For that I would like to thank you. I am equally thrilled to discover the unique colour palettes you select! Exploring your creative choices is my absolute favourite, and I cannot wait to watch all of your stunning blankets come to life.</p>
            <p>The CAL kicks off on September 12th and runs for six weeks through October 24th. There is no rush to complete your blanket within this timeframe, as all video tutorials will remain permanently accessible on my website.</p>
            <p><span className="fw-bold">PATTERN AVAILABLE FROM:</span></p>
            <ul>
                <li><a href="https://www.etsy.com/uk/listing/4366550825/crochet-pattern-cuddle-up-blanket" target="_blank">Etsy</a></li>
                <li><a href="https://www.ravelry.com/patterns/library/cuddle-up-blanket-4" target="_blank">Ravelry</a></li>
                <li><a href="https://www.woolwarehouse.co.uk/patterns-and-books/sylwia-witty-witty-crafts-designs-cuddle-up-blanket-in-yarnsmiths-create-dk-uk-terms-downloadable-pdf" target="_blank">Wool Warehouse UK Terms</a></li>
                <li><a href="https://www.woolwarehouse.co.uk/patterns-and-books/sylwia-witty-witty-crafts-designs-cuddle-up-blanket-in-yarnsmiths-create-dk-us-terms-downloadable-pdf" target="_blank">Wool Warehouse US Terms</a></li>
            </ul>
            <p><span className="fw-bold">DIFFICULTY LEVEL</span></p>
            <p>This Cuddle Up blanket is suitable for advanced beginners.</p>
            <p><span className="fw-bold">MATERIALS & TOOLS:</span></p>
            <ul>
                <li>DK/8 ply/light worsted weight yarn. This blanket was made in Yarnsmiths Create DK (100g/290m/317yd) in colours: Chocolate Brown, Burgundy, Copper, Parchment, Country Green, Rust, Latte,</li>
                <li>5mm (H) crochet hook, or size required to achieve the gauge. Please read Notes section for more details on crochet hook size used,</li>
                <li>scissors,</li>
                <li>yarn needle.</li>
            </ul>
            <p><span className="fw-bold">YARN QUANTITIES PER COLOUR:</span></p>
            <ul className="list-unstyled">
                <li><span className="fw-bold">A:</span> Chocolate Brown: 85g (used for the border)</li>
                <li><span className="fw-bold">B:</span> Burgundy: 115g</li>
                <li><span className="fw-bold">C:</span> Copper: 105g</li>
                <li><span className="fw-bold">D:</span> Parchment: 115g</li>
                <li><span className="fw-bold">E:</span> Country Green: 110g</li>
                <li><span className="fw-bold">F:</span> Rust: 115g</li>
                <li><span className="fw-bold">G:</span> Latte: 127g</li>
            </ul>
            <p>Yarn quantities provided are for a 120 cm x 120 cm sized blanket, please allow additional yarn if you wish to make your blanket larger.</p>
            <p>If you wish to make your blanket in the original colours, you can order the <a href="https://www.woolwarehouse.co.uk/packs/sylwia-witty-witty-crafts-design-cuddle-up-blanket-yarnsmiths-yarn-pack" target="_blank" rel="noreferrer">yarn pack from Wool Warehouse</a></p>
            <p><span className="fw-bold">SIZE</span></p>
            <p>Approx. 120 cm x 120 cm</p>
            <p><span className="fw-bold">BLANKET CONSTRUCTION</span></p>
            <p>The blanket is worked in the round and throughout on the right side and finished off with a border of berry stitches, worked on the wrong side. The size of the blanket can be easily adjusted, and made either smaller or larger, do bear in mind that this will affect the amount of yarn needed.</p>
            <p>You will need to know the below basic stitches.</p>
            <p className="text-center"><span className="fw-bold">UK CROCHET TERMINOLOGY</span></p>
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Abbreviation</th>
                            <th>Term</th>
                            <th>Abbreviation</th>
                            <th>Term</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="fw-bold">CH</td>
                            <td>chain</td>
                            <td className="fw-bold">LONG TR(s)</td>
                            <td>long treble(s)</td>
                        </tr>
                        <tr>
                            <td className="fw-bold">DC(s)</td>
                            <td>double crochet(s)</td>
                            <td className="fw-bold">BST(s)</td>
                            <td>berry stitch</td>
                        </tr>
                        <tr>
                            <td className="fw-bold">TR(s)</td>
                            <td>treble crochet(s)</td>
                            <td className="fw-bold">SL ST</td>
                            <td>slip stitch</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p className="text-center"><span className="fw-bold">US CROCHET TERMINOLOGY</span></p>
            <div className="table-responsive mb-4">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Abbreviation</th>
                            <th>Term</th>
                            <th>Abbreviation</th>
                            <th>Term</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="fw-bold">CH</td>
                            <td>chain</td>
                            <td className="fw-bold">LONG DC(s)</td>
                            <td>long double(s)</td>
                        </tr>
                        <tr>
                            <td className="fw-bold">SC(s)</td>
                            <td>single crochet(s)</td>
                            <td className="fw-bold">BST(s)</td>
                            <td>berry stitch</td>
                        </tr>
                        <tr>
                            <td className="fw-bold">DC(s)</td>
                            <td>double crochet(s)</td>
                            <td className="fw-bold">SL ST</td>
                            <td>slip stitch</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h2 className="fw-bold h1" id="week-1">Week 1</h2>
            <p>Welcome to Week 1 of the Cuddle Up Blanket crochet along! Thank you for being part of this journey. I hope this pattern brings warmth and creativity to your long autumn evenings, making them extra cosy and delightful.</p>
            <p>This week we will complete <span className="fw-bold">rounds 1 to 29</span> of the blanket.</p>
            <p><span className="fw-bold">PATTERN AVAILABLE FROM:</span></p>
            <ul>
                <li><a href="https://www.etsy.com/uk/listing/4366550825/crochet-pattern-cuddle-up-blanket" target="_blank">Etsy</a></li>
                <li><a href="https://www.ravelry.com/patterns/library/cuddle-up-blanket-4" target="_blank">Ravelry</a></li>
                <li><a href="https://www.woolwarehouse.co.uk/patterns-and-books/sylwia-witty-witty-crafts-designs-cuddle-up-blanket-in-yarnsmiths-create-dk-uk-terms-downloadable-pdf" target="_blank">Wool Warehouse UK Terms</a></li>
                <li><a href="https://www.woolwarehouse.co.uk/patterns-and-books/sylwia-witty-witty-crafts-designs-cuddle-up-blanket-in-yarnsmiths-create-dk-us-terms-downloadable-pdf" target="_blank">Wool Warehouse US Terms</a></li>
            </ul>
            <p>If visual learning suits you best, the video tutorials below can guide you through the pattern.</p>
            <div className="text-center mb-3">
                <p className="fw-bold h5">Long Treble (UK Terms)/ Long Double (US Terms)</p>
                <div class="ratio ratio-16x9">
                    <iframe src="https://www.youtube.com/embed/0LVNrWK-wuA?si=OiT2887MI5kx0rUG" title="YouTube video player" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <p className="fw-bold h5 mt-3">Corner Long Treble (UK Terms)/ Long Double (US Terms)</p>
                <div class="ratio ratio-16x9">
                    <iframe src="https://www.youtube.com/embed/3ko0vROHVs8?si=mqZwuNGVZZqaHjRU" title="YouTube video player" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <p className="fw-bold h5 mt-3">Placement of Long Treble (UK Terms)/ Long Double (US Terms)</p>
                <div class="ratio ratio-16x9">
                    <iframe src="https://www.youtube.com/embed/hBDpmrYkPb4?si=CSMJ49n0ipafuUHC" title="YouTube video player" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
            <p><span className="fw-bold">ADDITIONAL SUPPORT</span></p>
            <p>If you have any questions about the crochet along, please pop over and join my <a href="https://www.facebook.com/share/g/1HReHjfFWU/" target="_blank">Facebook group</a> where I'll be happy to help you.</p>
            
            <h2 className="fw-bold h1 mt-5" id="week-2">Week 2</h2>
            <p>Welcome to Week 2 of our Cuddle Up Blanket crochet along! I trust you have been thoroughly enjoying every stitch of this project so far.</p>
            <p>If you are joining our crochet along today, a very warm welcome to you! I hope crocheting this lovely autumn blanket brings you immense joy. To help you get started, useful video guides can be found under <a href="/cuddle-up-blanket-crochet-along/#week-1">week 1</a> of the crochet along.</p>
            <p>A heartfelt thank you for becoming part of our Facebook community and for sharing lovely photos showing your progress!</p>

            <p>For Week 2, we will be working through <span className="fw-bold">rounds 30 to 42</span> of the pattern.</p>

            <h2 className="fw-bold h1 mt-5" id="week-3">Week 3</h2>
            <p>I love seeing all of your Cuddle Up Blanket updates! Thank you so much for sharing them, it is wonderful to see how much everyone is enjoying this crochet along.</p>

            <p>For Week 3, we will be working through <span className="fw-bold">rounds 43 to 51</span> of the pattern.</p>

            <p>If you would like to join the crochet along, there’s still time.</p>

            <h2 className="fw-bold h1 mt-5" id="week-4">Week 4</h2>
            <p>Hello and welcome to Week 4! We have officially entered the second half of our crochet along—time has truly flown by!</p>

            <p>It brings me so much joy to see all of your beautiful blankets, so please keep sharing your updates and tagging me in your posts.</p>

            <p>For Week 4, we will be working through <span className="fw-bold">rounds 52 to 59</span> of the pattern.</p>

            <h2 className="fw-bold h1 mt-5" id="week-5">Week 5</h2>
            <p>Welcome to Week 5 of our CAL! I hope you are still having fun with the pattern and that your blanket is now large enough to keep you cosy as you work on it.</p>

            <p>For Week 5, our focus will be on <span className="fw-bold">rounds 60 to 67.</span></p>

            <h2 className="fw-bold h1 mt-5" id="week-6">Week 6</h2>
            <p>Welcome to week six—the final week of the Cuddle Up Blanket crochet along! Time has flown by so quickly. I have loved admiring all of your lovely blankets and am so delighted that so many of you joined in on this journey.</p>

            <p>To complete your blanket, we will be working on <span className="fw-bold">rounds 68 to 72 and the border.</span> Please check below for the video tutorial I recorded showing how to create the border.</p>

            <div className="text-center mb-3">
                <div class="ratio ratio-16x9">
                    <iframe src="https://www.youtube.com/embed/dN6o4zzg6mI?si=It26-xnlHbWZMAZZ" title="YouTube video player" frameborder="0" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>

            <p><span className="fw-bold">PATTERN AVAILABLE FROM:</span></p>
            <ul>
                <li><a href="https://www.etsy.com/uk/listing/4366550825/crochet-pattern-cuddle-up-blanket" target="_blank">Etsy</a></li>
                <li><a href="https://www.ravelry.com/patterns/library/cuddle-up-blanket-4" target="_blank">Ravelry</a></li>
                <li><a href="https://www.woolwarehouse.co.uk/patterns-and-books/sylwia-witty-witty-crafts-designs-cuddle-up-blanket-in-yarnsmiths-create-dk-uk-terms-downloadable-pdf" target="_blank">Wool Warehouse UK Terms</a></li>
                <li><a href="https://www.woolwarehouse.co.uk/patterns-and-books/sylwia-witty-witty-crafts-designs-cuddle-up-blanket-in-yarnsmiths-create-dk-us-terms-downloadable-pdf" target="_blank">Wool Warehouse US Terms</a></li>
            </ul>

            <p>As always, if you have any questions or need assistance, please pop over and join my <a href="https://www.facebook.com/share/g/1HReHjfFWU/" target="_blank">Facebook group</a> where I'll be delighted to assist.</p>
            <p>I would love to be a part of your Cuddle Up Blanket journey and see what colours you chose for your blanket, so please use <a href="https://www.instagram.com/#cuddleupblanketcal" className="fw-bold" target="_blank">#cuddleupblanketcal</a> when sharing posts or reels on Facebook or Instagram, and tag <a href="https://www.instagram.com/wittycraftsdesign" className="fw-bold" target="_blank">@wittycraftsdesign.</a></p>

            <p>Enjoy crocheting!</p>
            <p>Sylwia xxx</p>
        </>
    )
} export default CrochetAlong